import {axiosInstance, uncachedAxiosInstance, TILE_TTL} from "./base"
import axios from "axios"

export function getEventTypesQry(params) {  // FIXME DELETE THIS
    return axiosInstance.get(`api/events-types/`, {params})
}

export function getEventsQry(params) {  // FIXME DELETE THIS
    return axiosInstance.get(`api/events/`, {params})
}

export function getEventsIncomingQry() {
    return axiosInstance.get(`api/events-incoming/`, {})
}

export function getEventsIncomingByYearQry(year) {
    return axiosInstance.get(`api/events-incoming-year/${ year }`,{})
}

export function getEventsIncomingByCountryQry(iso) {
    return axiosInstance.get(`api/events-incoming-iso/${ iso }`,{})
}

export function deleteEventsIncomingQry(id) {
    return axiosInstance.delete(`api/events-incoming/${id}/`, {})
}

export function getCountriesByContinent(params, continent_value) {
    return axiosInstance.get(`api/countries/${continent_value}/`, {params})
}

export function postEventsQry(data) {
    return axiosInstance.post(`api/events/`, data, {})
}

export function postEventsIncomingQry(data) {
    return axiosInstance.post(`api/events-incoming/`, data, {})
}

export function putEventsQry(id, data) {
    return axiosInstance.put(`api/events/${id}/`, data, {})
}

export function optionsEventsQry() {
    return axiosInstance.options(`api/events/`, {})
}

export function deleteEventQry(id) {
    return axiosInstance.delete(`api/events/${id}/`, {})
}

export function getRiskQry(country) {
    return axiosInstance.get(`api/risks/${country}/`, {})
}
export function getGlobalRisks() {
    return axiosInstance.get(`api/risks/?page_size=500`, {})
}
export function patchRiskQry(country, data) {
    return axiosInstance.patch(`api/risks/${country}/`, data, {})
}

// Province risk API functions
export function getProvinceRisksQry(country, bustCache = false) {
    const params = bustCache ? { _t: Date.now() } : {};
    return axiosInstance.get(`api/province-risks/${country}/`, { params })
}

export function patchProvinceRiskQry(country, provinceRisksData) {
    // Send entire province list: { "Badakhshan": "R4", "Takhar": "R3", ... }
    return uncachedAxiosInstance.patch(`api/province-risks/${country}/`, provinceRisksData, {})
}

export function getCountryFactsQry(params) {
    return axiosInstance.get(`api/country-facts/`, {params})
}

export function deleteCountryFactQry(id) {
    return axiosInstance.delete(`api/country-facts/${id}/`, {})
}

export function postCountryFactsQry(data) {
    return axiosInstance.post(`api/country-facts/`, data, {})
}

export function putCountryFactsQry(id, data) {
    return axiosInstance.put(`api/country-facts/${id}/`, data, {})
}

export function patchCountryFactsQry(id, data) {
    return axiosInstance.patch(`api/country-facts/${id}/`, data, {})
}

export function getFactTypeQry(slug) {
    return axiosInstance.get(`api/country-facts-types/${slug}/`, {})
}

export function getPointOfInterestQry(params) {
    return axiosInstance.get(`api/points-of-interest/`, {params})
}

export function getPointOfInterestTilesQry(tiles, zoom, params) {
    var requests = tiles.map(coords => {
        return axiosInstance.get(`api/points-of-interest/tiles/${zoom}/${coords[0]}/${coords[1]}/`,
                                {params, ttl: TILE_TTL})
    });
    return axios.all(requests)
}

export function postPointOfInterestQry(data) {
    return axiosInstance.post(`api/points-of-interest/`, data, {})
}

export function putPointOfInterestQry(id, data) {
    return axiosInstance.put(`api/points-of-interest/${id}/`, data, {})
}

export function deletePointOfInterestQry(id) {
    return axiosInstance.delete(`api/points-of-interest/${id}/`, {})
}

export function optionPointOfInterestQry() {
    return axiosInstance.options(`api/points-of-interest/`, {})
}

export function getBonASavoirQry(country) {
    return axiosInstance.get(`api/countrycontent/bon-a-savoir/${country}/`, {})
}

export function updateBonASavoirQry(country, data) {
    return uncachedAxiosInstance.post(`api/countrycontent/bon-a-savoir/${country}/`, data, {})
}

export function getCountryContentSectionQry(country, sectionName) {
    return axiosInstance.get(`api/countrycontent/section/${country}/${sectionName}/`, {})
}

export function updateCountryContentSectionQry(country, sectionName, data) {
    return uncachedAxiosInstance.post(`api/countrycontent/section/${country}/${sectionName}/`, data, {})
}
